export default "<json-editor (focusout)=\"validateAndGetData(data)\"  [options]=\"options\" [data]=\"data['sampleData']\"\n></json-editor>\n"